module.exports = __webpack_public_path__ + "media/Video (14).aa39f0c4.mp4";